var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueSquareFlower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.000696182 17.7744C4.90769 17.7744 8.88672 13.7954 8.88672 8.887H-0.000696182V17.7744Z",
    fill: "#3498DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88672 8.88741C8.88672 3.97903 12.8658 1.73929e-07 17.7741 3.88481e-07L17.7741 8.88742L8.88672 8.88741Z",
    fill: "#3498DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88741 8.8877C3.97903 8.8877 6.95716e-07 4.90866 1.55392e-06 0.00028038L8.88742 0.000281934L8.88741 8.8877Z",
    fill: "#3498DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7734 17.7751C17.7734 12.8667 13.7944 8.8877 8.88602 8.88769L8.88602 17.7751L17.7734 17.7751Z",
    fill: "#3498DB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSquareFlower);
export default __webpack_public_path__ + "static/media/blue-square-flower.cd9de6f69fdfeaa350d82e329d75fe2a.svg";
export { ForwardRef as ReactComponent };